class SellingPlanSelector extends HTMLElement {

    constructor() {
        super()
        this.cartDrawerItem = this.closest(".m-cart-drawer--item");
        this.itemId = this.cartDrawerItem?.id;

        const dataset = this.cartDrawerItem?.dataset;
        this.itemLine = dataset?.index;
        this.itemQuantity = dataset?.quantity;

        this.sellingPlan = dataset?.sellingPlan;

        this.checkBox = this.querySelector("#add_subscription_checkbox");
        this.checkBox.addEventListener("click", () => {
            this.changeSellingPlan();
        });
    }

    async changeSellingPlan() {
        this.sellingPlanChecked = this.querySelector("#add_subscription_checkbox").checked;
        let body = {};
        if (this.sellingPlanChecked == true) {
            body = JSON.stringify({
                'line': Number(this.itemLine),
                'quantity': Number(this.itemQuantity),
                'selling_plan': Number(this.sellingPlan),
                'sections': 'cart-drawer',
                "sections_url": window.location.pathname
            });
        } else {
            body = JSON.stringify({
                'line': Number(this.itemLine),
                'quantity': Number(this.itemQuantity),
                'selling_plan': null,
                'sections': 'cart-drawer',
                "sections_url": window.location.pathname
            });
        }

        await fetch(`/cart/change.js`, { ...this.fetchConfig(), body: body })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.newDom = new DOMParser().parseFromString(parsedState?.sections['cart-drawer'], 'text/html');

                const cartDrawerBody = document.querySelector('.m-cart-drawer--body');
                if(cartDrawerBody) {
                    cartDrawerBody.innerHTML = this.newDom.querySelector(".m-cart-drawer--body")?.innerHTML;
                }

                const cartSummary = document.querySelector('.m-cart--summary');
                if(cartSummary) {
                    cartSummary.innerHTML = this.newDom.querySelector('.m-cart--summary')?.innerHTML;
                }
            }).catch((err) => {
                console.log(err);
            });
    }

    fetchConfig(type = "json") {
        return {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: `application/${type}` },
        };
    }
}

customElements.define('selling-plan-selector', SellingPlanSelector)